import styled from "styled-components";
import { colors, breakpoints } from "definitions";

/* ---------------------------------------------------------------------------
   Pasos de la postulación
   ---------------------------------------------------------------------------
   Antes eran tres bloques azules solapados -30px entre sí, con el número en
   40px y la descripción al lado; por debajo de 896px la descripción se ocultaba
   y quedaban sólo "01 02 03", sin decir qué era cada paso. Ahora son tres
   puntos unidos por una línea: el paso hecho muestra un tilde y, debajo,
   la temática y el premio que se eligieron.
--------------------------------------------------------------------------- */

const markSize = "3.4rem";

export const BreadcrumbContainer = styled.nav`
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 4.6rem 0;
  padding: 0 2.4rem;

  ${breakpoints.tablet} {
    margin: 3.2rem 0;
    padding: 0 1.6rem;
  }
`;

export const BreadcrumbList = styled.ol`
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  width: 100%;
  max-width: 72rem;
  margin: 0;
  padding: 0;
  list-style: none;

  /* La línea une los centros de los tres puntos: arranca en el primero y
     termina en el tercero, no en los bordes del contenedor. */
  ::before {
    content: "";
    position: absolute;
    left: 16.666%;
    right: 16.666%;
    top: calc(${markSize} / 2 - 1px);
    height: 2px;
    background: #dde3ee;
  }
`;

export const BreadcrumbItem = styled.li`
  display: grid;
  justify-items: center;
  gap: 0.8rem;
  min-width: 0;
  text-align: center;
`;

export const BreadcrumbMark = styled.span`
  position: relative;
  display: grid;
  place-items: center;
  width: ${markSize};
  height: ${markSize};
  border-radius: 50%;
  border: 2px solid
    ${({ $state }) =>
      $state === "todo" ? "#dde3ee" : colors.icons.yellowGreen};
  background: ${({ $state }) =>
    $state === "done" ? colors.icons.yellowGreen : colors.background.white};
  color: ${({ $state }) =>
    $state === "done"
      ? colors.fonts.white
      : $state === "current"
      ? colors.fonts.yellowGreen
      : "#9aa5b5"};
  font-family: Lato;
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 1;

  box-shadow: ${({ $state }) =>
    $state === "current" ? "0 0 0 4px rgba(0, 110, 223, 0.14)" : "none"};

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

export const BreadcrumbText = styled.span`
  display: grid;
  gap: 0.2rem;
  min-width: 0;
`;

export const BreadcrumbTitle = styled.span`
  font-family: Lato;
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 1.9rem;
  color: ${({ $state }) =>
    $state === "todo" ? "#9aa5b5" : colors.fonts.darkGray};

  ${breakpoints.phablet} {
    font-size: 1.2rem;
  }
`;

// El nombre de lo ya elegido. En pantallas chicas se oculta para que los tres
// rótulos entren en una línea.
export const BreadcrumbDetail = styled.span`
  font-family: Lato;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.7rem;
  color: #7b889f;
  overflow-wrap: anywhere;

  ${breakpoints.tablet} {
    display: none;
  }
`;
